import { render, staticRenderFns } from "./BookingSimcard.vue?vue&type=template&id=728503f2&scoped=true&"
import script from "./BookingSimcard.vue?vue&type=script&lang=js&"
export * from "./BookingSimcard.vue?vue&type=script&lang=js&"
import style0 from "./BookingSimcard.vue?vue&type=style&index=0&id=728503f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728503f2",
  null
  
)

export default component.exports